import locator from '~/services/locator';
import RootStore from '~/state/store';
import UiStore from '~/state/store/Ui.store';
import PartialStore from '~/state/store/Partial.store';
import Transport from '~/state/store/Transport';

const state = new RootStore(
    new UiStore(
        locator.matchMedia,
        locator.translator,
        locator.elementRenderer,
    ),
    new PartialStore(
        locator.apiService
    ),
);

type TState = typeof state;
interface IState extends TState {}

export default state;
export { IState };
